var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { HttpRequestMethod } from 'http-core-constants';
import { ObjectUtil } from '../util/objectUtil';
export var CustomerIOEventType;
(function (CustomerIOEventType) {
    CustomerIOEventType["page"] = "page";
    CustomerIOEventType["event"] = "event";
})(CustomerIOEventType || (CustomerIOEventType = {}));
export class CustomerIOClient {
    constructor(siteId, apiKey) {
        this.baseUrl = 'https://track.customer.io/api/v1/';
        this.siteId = siteId;
        this.apiKey = apiKey;
        const authorization = btoa(`${this.siteId}:${this.apiKey}`);
        this.authorization = `Basic ${authorization}`;
    }
    identify(customerId, anonymousId, email, data) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.callAPI(`customers/${customerId}`, HttpRequestMethod.PUT, ObjectUtil.removeUndefined(Object.assign({ id: customerId, anonymous_id: anonymousId, email }, data)));
        });
    }
    trackAnonymous(anonymousId, name, data) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.callAPI('events', HttpRequestMethod.POST, {
                anonymous_id: anonymousId,
                name,
                type: CustomerIOEventType.event,
                data
            });
        });
    }
    track(customerId, name, data) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.callAPI(`customers/${customerId}/events`, HttpRequestMethod.POST, {
                name,
                type: CustomerIOEventType.event,
                data
            });
        });
    }
    callAPI(path, method, body) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield fetch(`${this.baseUrl}${path}`, {
                headers: {
                    Authorization: this.authorization
                },
                method,
                body: JSON.stringify(body)
            });
            if (!response.ok) {
                throw new Error(yield response.text());
            }
        });
    }
}
//# sourceMappingURL=data:application/json;base64,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